import { ciHttpRequest } from '@/utils/CiHttpRequest';
import { IPage } from "@/types/FmsCiTypes";
import {
	IMaintenanceDetail,
	IItemDetailList,
	ThreeGuaranteesItemDetailList,
	IMaterialDetailList,
	OtherItemDetailList
} from './vrmBillMaintenanceType';

class MaintenanceService {

	async one(tradeCode: string) {
		const apiUrl = `/ci/order/platform_one_code/${tradeCode}`;
		return await ciHttpRequest.post<IMaintenanceDetail>(apiUrl);
	}

	async itemList(param: any) {
		const apiUrl = `/ci/order/item/list`;
		return await ciHttpRequest.post<IPage<IItemDetailList>>(apiUrl, param);
	}

	async threeGuaranteesList(param: any) {
		const apiUrl = `/ci/order_three_guarantees/list`;
		return await ciHttpRequest.post<IPage<ThreeGuaranteesItemDetailList>>(apiUrl, param);
	}

	async materialList(param: any) {
		const apiUrl = `/ci/order/maintan-material/list`;
		return await ciHttpRequest.post<IPage<IMaterialDetailList>>(apiUrl, param);
	}

	async otherItemDetailList(param: any) {
		const apiUrl = `/ci/order/other-item/list`;
		return await ciHttpRequest.post<IPage<OtherItemDetailList>>(apiUrl, param);
	}

}
export const maintenanceService = new MaintenanceService();
